<template>
    <v-dialog :value="show" @input="propogateInput" width="500">
      
      <v-card>
        <v-card-title>
            permanently delete your account ?
        </v-card-title>
        <v-card-text>
            Are you sure you want to permanently delete your account. This action is irreversible.
        </v-card-text>
        <v-divider/>
        <v-card-action>
            <v-btn color="primary" text @click="$emit('input',false)" > Cancel </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="$emit('confirm')"
            >
            Delete
          </v-btn>
        </v-card-action>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:'AccidentalGaurd',
    props:['dialog'],
    model: {
      prop: 'dialog',
      event: 'input'
  },
    created(){
        this.show = this.dialog
    },
    data: function() {
        return {
            show: this.dialog
        }
  },
  watch:{
    dialog(newVal){
        this.show = newVal
        console.log('val change',newVal)
    }
  },
    methods:{
        propogateInput(val){
            this.$emit('input',val)
        }

    }
}
</script>
